import { green } from "@ant-design/colors"
import { faRotateLeft } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Alert, Card, ConfigProvider, Form, Input, Space } from "antd"
import theme from 'antd/lib/theme'
import { useEffect } from "react"
import ThemableButton from "../Items/ThemableButton"
import { useResetPasswordMutation } from "./authenticationQueries"
import { PasswordRequirements, PASSWORD_REGEX } from "./PasswordRequirements"

export type Props = {
  token: string
  email: string
}

const ResetPassword = ({ token, email }: Props) => {
  const [form] = Form.useForm()
  const password = Form.useWatch('password1', form)

  const resetPasswordMutation = useResetPasswordMutation()

  const handleSubmit = () => {
    resetPasswordMutation.mutate({ email, token, password })
  }

  useEffect(() => {
    if (resetPasswordMutation.isSuccess) {
      window.location.href = '#!/account'
    }
  }, [resetPasswordMutation.isSuccess])

  return <div className="sign-in-container">
    <Space direction="vertical" size="middle" style={{ maxWidth: 400, padding: 8 }}>
      <img src="/images/synkedup-dark.png" alt="SynkedUP" style={{ maxWidth: '100%' }} />
      {!resetPasswordMutation.isSuccess && <>
        <Form form={form} layout="vertical" size="large" onFinish={handleSubmit}>
          <Form.Item name="password1" rules={[
            { required: true, message: 'Password is required' },
            { pattern: PASSWORD_REGEX, message: 'Password does not meet the requirements' },
          ]}>
            <Input.Password placeholder="New Password" />
          </Form.Item>
          <Form.Item
            name="password2"
            rules={[
              {
                validator: (_, value) => {
                  const password1 = form.getFieldValue('password1')
                  if (password1 !== value) {
                    return Promise.reject('Passwords must match')
                  }
                  return Promise.resolve()
                },
              }
            ]}>
            <Input.Password placeholder="Confirm New Password" />
          </Form.Item>
          <Form.Item hidden={!resetPasswordMutation.isError}>
            <Alert message={(resetPasswordMutation.error as Error)?.message} type="error" showIcon />
          </Form.Item>
          <Form.Item>
            <ConfigProvider theme={{ algorithm: theme.darkAlgorithm }}>
              <Card style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                <PasswordRequirements password={password} textColor="#eee" />
              </Card>
            </ConfigProvider>
          </Form.Item>
          <Form.Item>
            <ThemableButton
              htmlType="submit"
              type="primary"
              colorPrimary={green.primary}
              icon={<FontAwesomeIcon icon={faRotateLeft} />}
              loading={resetPasswordMutation.isLoading}
            >
              Change Password
            </ThemableButton>
          </Form.Item>
        </Form>
      </>}
      {resetPasswordMutation.isSuccess && <Alert message={resetPasswordMutation.data as string} type="success" showIcon />}
    </Space>
  </div>
}

export default ResetPassword
